export const loginTitle = "Log in to\nFYVE Tenant Platform";

export const loginInputPlaceholder = "Enter mobile phone number or email";

export const managerMessage =
  "Thank you! Our manager will contact you shortly and solve your problem.";
